import image from "assets/img/realEstate/image.png";
import image2 from "assets/img/realEstate/image (1).png";
import Rectangle from "assets/img/realEstate/Rectangle 5936.png";
import imageB5 from "assets/img/realEstate/image (5).png";
import imageB2 from "assets/img/realEstate/image (2).png";
import imageB3 from "assets/img/realEstate/image (3).png";
import imageB4 from "assets/img/realEstate/image (4).png";
import Wrapper from "assets/img/realEstate/Image Wrapper.png";
import ServiceSection from "../../../components/InfoCard";
import "./index.scss";

const realData = [
  {
    title: "Real Estate Engineering Construction",
    content:
      "Super5 Group has rich experience and a professional team in the field of real estate construction, and is committed to creating high-quality and unique construction projects. We pay attention to details to ensure that projects are completed on time and with quality.",
    imageUrl: image,
  },
  {
    title: "Labor Services",
    content:
      "As an important part of real estate development, Super5 provides flexible and efficient labor services, including human resources management, construction personnel recruitment and training, etc., and continues to provide labor services to many real estate construction companies around the world.",
    imageUrl: image2,
  },
];

const lndustrialData = [
  {
    title: "Lndustrial Real Estate Development",
    content:
      "In addition to residential and commercial projects, Super5 also focuses on industrial real estate development, providing high-quality industrial parks and factories for manufacturing and logistics companies.",
    imageUrl: imageB2,
  },
  {
    title: "Real estate design services",
    content:
      "Super5 focuses on the innovation and practicality of real estate design. Super5 Design Company is headquartered in Tokyo, Japan, and provides design solutions that meet local standards and market needs for global users.",
    imageUrl: imageB3,
  },
  {
    title: "Vacation Home Operations",
    content:
      "Super5 is committed to creating unique and comfortable vacation rentals, providing a full range of vacation residence services for high-end users around the world.",
    imageUrl: imageB4,
  },
  {
    title: "Chilaoz Apartment",
    content:
      "Super5 is committed to creating a comfortable, convenient and dynamic living environment for young people. it's here,You can unleash your youthful passion and realize your dreams in life.",
    imageUrl: imageB5,
  },
];

const Content = () => (
  <>
    <div className="automotive-solutions real_content">
      {realData.map((section, index) => (
        <ServiceSection
          key={index}
          title={section.title}
          content={section.content}
          imageUrl={section.imageUrl}
          isImageRight={index % 2 === 0}
          textClassName="text_width"
        />
      ))}
    </div>
    <div className="realEstate_box">
      <div className="content_box">
        <div className="title">Construction Machinery Rental</div>
        <div className="desc">
          Super5 has advanced construction machinery and equipment and provides
          various types of machinery rental services, including cranes,
          excavators, loaders, etc., to meet the needs of different projects.
        </div>
        <div className="img_box">
          <img src={Rectangle} alt=""></img>
        </div>
      </div>
    </div>
    <div className="automotive-solutions real_content">
      {lndustrialData.map((section, index) => (
        <ServiceSection
          key={index}
          title={section.title}
          content={section.content}
          imageUrl={section.imageUrl}
          isImageRight={index % 2 === 0}
          textClassName="text_width"
          imgClassName="img_box"
        />
      ))}
    </div>
    <div className="building_materials">
      <div className="image_container">
        <img src={Wrapper} alt=""></img>

        <div className="content">
          <h1>BUILDING MATERIALS IMPORT AND EXPORT TRADING SERVICES</h1>
          <p>
            As an important support for real estate construction, Super5
            provides import and export trade services of building materials to
            ensure the construction quality and progress of the project.
          </p>
        </div>
      </div>
    </div>
  </>
);

export default Content;
